import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CanComponentDeactivate } from '@klickdata/core/auth';
import { Group } from '@klickdata/core/group';
import { MobileService } from '@klickdata/core/mobile';
import { MsgCase } from '@klickdata/core/notification';
import { GlobalFilterProperty, SelectFilterOption } from '@klickdata/core/table';
import { Utils } from '@klickdata/core/util';
import { SelectModelBaseDirective } from '../select-model-base/select-model-base.component';
import { CasesService } from './cases.service';

@Component({
    selector: 'app-cases-select',
    templateUrl: './cases-select.component.html',
    styleUrls: ['./cases-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CasesSelectComponent
    extends SelectModelBaseDirective<MsgCase>
    implements OnInit, AfterViewInit, CanComponentDeactivate, OnDestroy
{
    @Input() accessForm: FormGroup;
    @Input() referenceFilter = 'referenceCase';
    @Input() referenceIdKey = 'id';
    @Input() customer_id: number;
    public columns = ['select', 'title', 'created_at', 'updated_at'];
    protected sync_all_key = 'sync_all_cases';
    protected attachKey = 'cases_attach';
    protected detachKey = 'cases_detach';
    public itemSelectedOptions: SelectFilterOption[];
    GlobalFilterProperty = GlobalFilterProperty;

    constructor(protected casesService: CasesService, protected mobile: MobileService) {
        super(casesService, mobile);
        this.itemSelectedOptions = Utils.getItemSelectedOptions();
    }

    /**
     * @override
     * @param id
     */
    protected refresh(id?: any): void {
        const filters = [];
        if (this.referenceFilter) {
            filters.push({ property: this.referenceFilter, items: [id] });
        }
        if (this.customer_id) {
            filters.push({ property: 'customer', items: [this.customer_id] });
        }
        this.filter.createOrUpdateFilter(filters);
    }

    detectIdKeyValueChange() {
        if (this.referenceFilter) {
            super.detectIdKeyValueChange();
        } else {
            this.refresh();
        }
    }
}
